import { DocumentFormDto, type DocumentFormInterface } from '@zaoblako/shared/modules/document/dtos/document/document-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { DocumentTypeCodeValidateTools } from '@zaoblako/shared/modules/document/classes/document.type.code.validate.tools';
import { DocumentSourceEnum } from '@zaoblako/shared/modules/document/enums/document-source.enum';
import { DocumentSourceEnumI18n } from '@zaoblako/shared/modules/document/i18n/document-source-enum.i18n';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { DocumentTypeFindInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-find.dto';

import * as yup from 'yup';

/** Allowed document sources for creating document */
export type AllowedSource = DocumentSourceEnum.FRM | DocumentSourceEnum.BALANCE_SHEET;

const ALLOWED_SOURCES: AllowedSource[] = [DocumentSourceEnum.FRM, DocumentSourceEnum.BALANCE_SHEET];

/** Document create API request body */
export interface DocumentCreateInterface extends DocumentFormInterface {
  /** Document type */
  documentType: DocumentTypeFindInterface;
  /** Document source */
  source?: DocumentSourceEnum;
  /** If `true` then spawned document will be created */
  isCreateLinkedDocument?: boolean;
}

/** Document create API request body - DTO schema */
export const DocumentCreateDto = SerdeDtoClass.from<DocumentFormInterface, DocumentCreateInterface>(
  DocumentFormDto,
  DocumentDtoKeysEnum.DOCUMENT_CREATE_DTO,
  {
    documentType: {
      label: 'Тип документа',
      serializer: (): yup.Schema<any> => {
        const tools = DocumentTypeCodeValidateTools.getInstance();
        return yup.object({
          code: yup
            .string()
            .matches(tools.matchRegex, tools.errorMessage),
        });
      },
    },
    source: {
      optional: true,
      label: 'Источник документа',
      default: DocumentSourceEnum.FRM,
      serializer: context => yup
        .string()
        .oneOf(
          ALLOWED_SOURCES,
          () => {
            const locale = context?.data?.locale || I18nLocalesEnum.RU_RU;
            const values = ALLOWED_SOURCES
              .map(source => `"${source}" (${DocumentSourceEnumI18n[locale][source]})`)
              .join(', ');
            return `Допускаются только следующие значения: ${values}`;
          },
        ),
    },
    isCreateLinkedDocument: {
      optional: true,
      label: 'Создать связанный документ',
      serializer: yup.boolean(),
    },
  },
);
